<div class="forms">
  <form [formGroup]="form">
    <div class="row">
      <div class="form-group">
        <span class="icon" [ngClass]="tipoVeiculo"></span>
        <div class="inputs field-group">
          <label *ngIf="!isInformarManualmente && !(fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro?._tipo && veiculos.length === 1)"
            for="veiculoPlaca">
            Placa do Veículo
          </label>
          <input [ngClass]="{'dn': isZeroKm || fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro?._tipo && veiculos.length === 1}"
            type="text" class="form-control" id="veiculoPlaca" placeholder="BRA0S17" license-plate name="veiculoPlaca"
            formControlName="veiculoPlaca" [licensePlateCheck]="veiculoPlaca" duplicidadeMessage="Placa duplicada"
            appShowErrorMessages>

          <div class="switch-row field-group__pesados">
            <div class="switch-group">
              <app-switch id="veiculo-utilizacaoAgropecuaria" name="utilizacaoAgropecuaria"
                formControlName="isUtilizacaoAgropecuaria">
              </app-switch>
              <span class="radio-label">Utilização agropecuária</span>
            </div>
          </div>

          <div *ngIf="!isInformarManualmente && !(fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro?._tipo && veiculos.length === 1)" class="switch-row field-group__outro-comprovante">
            <div class="switch-group">
              <app-switch id="veiculo-veiculoKM" formControlName="isZeroKm" name="veiculoKM"
                (change)="onClickVeiculoKM()">
              </app-switch>
              <span class="radio-label">Veículo 0km</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel__veiculo blue-box new-car row"
      [ngClass]="{'dn': !isZeroKm  && !(fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro?._tipo && veiculos.length === 1), 'blue-box-p': isAlterar}">
      <div>
        <div class="form-group pb0" *ngIf="isPlacaInvalida">
          <span class="icon car"></span>
          <div class="inputs">
            <label for="user-mobile">Placa</label>
            <input
              type="text"
              readonly
              class="form-control"
              formControlName="veiculoPlaca"
            />
          </div>
        </div>
        <div class="form-group pb0">
          <span class="icon" [ngClass]="{'car': !isPlacaInvalida}"></span>
          <div class="inputs">
            <label for="categoria-veiculo">Categoria do Veículo</label>
            <select formControlName="veiculoCategoria" appShowErrorMessages [hidden]="!isLoadingTipoVeiculo"
              class="form-control" name="categoria-veiculo" (change)="onChangeTipoVeiculo($event)"
              (blur)="onBlurTipoVeiculo($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let tv of listaTipoVeiculo" value="{{ tv.id }}">{{ tv.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedTipoVeiculoAfterBlur">Categoria do Veículo é obrigatória</div>
            <span *ngIf="isLoadingTipoVeiculo">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="marca-veiculo">Marca do Veículo</label>
            <select formControlName="veiculoMarca" name="marca-veiculo" appShowErrorMessages [hidden]="!isLoadingMarca"
              class="form-control" (change)="onChangeMarca($event)"
              (blur)="onBlurMarca($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let ma of listaMarca" [ngValue]="ma">{{ ma.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedMarcaAfterBlur && !isLoadingMarca">Marca do Veículo é obrigatória
            </div>
            <span *ngIf="isLoadingMarca">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="ano-veiculo">Ano do Veículo</label>
            <select formControlName="veiculoAno" name="ano-veiculo" [hidden]="!isLoadingAnoModelo"
              id="vehicle-model-year" class="form-control"
              (change)="onChangeAnoModelo($event)" appShowErrorMessages (blur)="onBlurAnoModelo($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let am of listaAnoModelo" value="{{ am.anoModelo }}">{{ am.anoModelo }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedAnoModeloAfterBlur">Ano Modelo do Veículo é obrigatório</div>
            <span *ngIf="isLoadingAnoModelo">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="modelo-veiculo">Modelo do Veículo</label>
            <select formControlName="veiculoModelo" name="modelo-veiculo" [hidden]="!isLoadingModelo"
              id="vehicle-model" class="form-control" appShowErrorMessages
              (change)="onChangeModelo($event)" (blur)="onBlurModelo($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let mo of listaModelo" [ngValue]="mo">{{ mo.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedModeloAfterBlur">Modelo do Veículo é obrigatório</div>
            <span *ngIf="isLoadingModelo">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="versao-veiculo">Versão do Veículo</label>
            <select formControlName="veiculoVersao" name="versao-veiculo"
              id="vehicle-version" class="form-control" appShowErrorMessages (change)="onChangeVersao($event)"
              (blur)="onBlurVersao($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let ve of listaVersao" [ngValue]="ve">{{ ve.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedVersaoAfterBlur">Versão do Veículo é obrigatória</div>
            <span *ngIf="isLoadingVersao">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': isAlterar}">
          <span class="icon"></span>
          <div class="inputs">
            <label for="cor-veiculo">Cor do Veículo</label>

            <select class="form-control" formControlName="veiculoCor" name="cor-veiculo">
              <option value="" hidden selected>Selecione...</option>
              <option value="AMARELA">AMARELA</option>
              <option value="AZUL">AZUL</option>
              <option value="BRANCA">BRANCA</option>
              <option value="CINZA">CINZA</option>
              <option value="DOURADA">DOURADA</option>
              <option value="FANTASIA">FANTASIA</option>
              <option value="GRENÁ">GRENÁ</option>
              <option value="LARANJA">LARANJA</option>
              <option value="MARROM">MARROM</option>
              <option value="PRATA">PRATA</option>
              <option value="PRETA">PRETA</option>
              <option value="ROSA">ROSA</option>
              <option value="ROXA">ROXA</option>
              <option value="VERDE">VERDE</option>
              <option value="VERMELHA">VERMELHA</option>
            </select>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': isAlterar}">
          <span class="icon"></span>
          <div class="inputs">
            <label for="veiculoCombustivel-veiculo">Tipo de Combustível</label>

            <select class="form-control" formControlName="veiculoCombustivel" name="veiculoCombustivel-veiculo">
              <option value="" hidden selected>Selecione...</option>
              <option *ngFor="let tipocombustivel of listaTiposCombustiveis" [value]="tipocombustivel.description">{{tipocombustivel.description}}</option>
            </select>
          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="form-group">
        <span class="icon state"></span>
        <div class="inputs">
          <label for="uf-licensing">Estado de Licenciamento</label>
          <select required appShowErrorMessages requiredMessage="Selecionar UF de licenciamento é obrigatório"
            formControlName="ufLicenciamento" name="uf-licensing" class="form-control" id="uf-licensing"
            (change)="onChangeUfLicenciamento($event)">
            <option value="" selected hidden>Selecione...</option>
            <option value="AC">AC - Acre</option>
            <option value="AL">AL - Alagoas</option>
            <option value="AP">AP - Amapá</option>
            <option value="AM">AM - Amazonas</option>
            <option value="BA">BA - Bahia</option>
            <option value="CE">CE - Ceará</option>
            <option value="DF">DF - Distrito Federal</option>
            <option value="ES">ES - Espírito Santo</option>
            <option value="GO">GO - Goiás</option>
            <option value="MA">MA - Maranhão</option>
            <option value="MT">MT - Mato Grosso</option>
            <option value="MS">MS - Mato Grosso do Sul</option>
            <option value="MG">MG - Minas Gerais</option>
            <option value="PA">PA - Pará</option>
            <option value="PB">PB - Paraíba</option>
            <option value="PR">PR - Paraná</option>
            <option value="PE">PE - Pernambuco</option>
            <option value="PI">PI - Piauí</option>
            <option value="RJ">RJ - Rio de Janeiro</option>
            <option value="RN">RN - Rio Grande do Norte</option>
            <option value="RS">RS - Rio Grande do Sul</option>
            <option value="RO">RO - Rondônia</option>
            <option value="RR">RR - Roraima</option>
            <option value="SC">SC - Santa Catarina</option>
            <option value="SP">SP - São Paulo</option>
            <option value="SE">SE - Sergipe</option>
            <option value="TO">TO - Tocantins</option>
          </select>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="veiculos && veiculos.length <= 3 && !dontShowButtons" class="row marginT30 form-group tab-buttons">
    <a (click)="onClickCancelar()" *ngIf="!canAdd && !(fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro?._tipo)" class="bt-back btn btn-border-orange pull-left">
      Cancelar
    </a>

    <a (click)="onClickSalvar()" *ngIf="!canAdd && !(fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro?._tipo)" [ngClass]="{'disabled': !formValid}"
      class="bt-back btn btn-full-orange pull-right">
      Salvar Veículo
    </a>

    <ng-container *ngIf="multipleOffer">
    <a (click)="onClickAdd()" *ngIf="canAdd && !unicoVeiculoEditandoManualmente" [ngClass]="{'disabled': !formValid}"
      class="bt-back btn btn-border-orange pull-left">
      <i class="fa fa-plus mrBt"></i> Adicionar Veículo</a>
    </ng-container>
  </div>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'"></app-modal-message>
